import {
  ApplicationConfig,
  inject,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection,
} from '@angular/core';
import { Routes, provideRouter, withInMemoryScrolling } from '@angular/router';
import { appRoutes } from './app.routes';
import { HttpInterceptorFn, provideHttpClient, withInterceptors } from '@angular/common/http';
import { authInterceptor } from './core/http/interceptors/auth.interceptor';
import { perimeterDevInterceptor } from './core/http/interceptors/perimeter-dev.interceptor';
import { traceInterceptor } from './core/http/interceptors/trace.interceptor';
import { provideAnimations } from '@angular/platform-browser/animations';
import { AppReleaseService } from './core/app-release/app-release.service';
import { API_BASE_URL } from '@api-clients/core';
import { environment } from '@env';

/**
 * Configuración de la app. Los parámetros solo los usa `main.mock.ts`:
 *  - `terminalInterceptors` se ejecutan DESPUÉS de los de la app (trace → perimeter → auth),
 *    así que ya reciben los headers finales.
 *  - `devRoutes` se registran antes que las rutas reales (p. ej. la galería de UI).
 */
export const buildAppConfig = (
  terminalInterceptors: HttpInterceptorFn[] = [],
  devRoutes: Routes = [],
): ApplicationConfig => ({
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideAppInitializer(() => inject(AppReleaseService).load()),
    provideRouter([...devRoutes, ...appRoutes], withInMemoryScrolling({ scrollPositionRestoration: 'enabled' })),
    provideHttpClient(
      withInterceptors([traceInterceptor, perimeterDevInterceptor, authInterceptor, ...terminalInterceptors]),
    ),
    provideAnimations(),
    { provide: API_BASE_URL, useValue: environment.apiBaseUrl },
  ],
});

export const appConfig: ApplicationConfig = buildAppConfig();
